import { useEffect, useState } from "react";
import Header from "./Header";
import axios from "axios";

function AdminDashboard() {
  const [projects, setProjects] = useState({
    total: 0,
    newProjects: 0,
    gapFunding: 0,
    newProjectsPending: 0,
    gapFundingPending: 0,
  });
  const [loading, setLoading] = useState(true);
  const [ready, setReady] = useState([0]);
  const [content, setContent] = useState([0]);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const response = await axios.get(
          "http://fundoramaa.co.in//api/v1/projects/admin/"
        );

        if (response.data?.data && Array.isArray(response.data.data)) {
          const projects = response.data.data;

          const newProjects = projects.filter(
            (project) => project.category === "new project"
          );
          const gapFundingProjects = projects.filter(
            (project) => project.category === "gap funding"
          );

          const newProjectsPending = newProjects.filter(
            (project) =>
              project.ottUpdates &&
              project.ottUpdates.toLowerCase() === "pending"
          ).length;

          const gapFundingPending = gapFundingProjects.filter(
            (project) =>
              project.ottUpdates &&
              project.ottUpdates.toLowerCase() === "pending"
          ).length;

          setProjects({
            total: projects.length,
            newProjects: newProjects.length,
            gapFunding: gapFundingProjects.length,
            newProjectsPending: newProjectsPending,
            gapFundingPending: gapFundingPending,
          });
        } else {
          console.error("Unexpected response format:", response.data);
        }
      } catch (error) {
        console.error("Error fetching projects:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchProjects();
  }, []);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const response = await axios.get(
          `http://fundoramaa.co.in//api/v1/ready-to-release/admin/`
        );
        if (response.data && Array.isArray(response.data.data)) {
          setReady(response.data.data.length);
        } else {
          console.error("Unexpected response format:", response.data);
          setReady([]);
        }
      } catch (error) {
        console.error("Error fetching projects:", error);
        setReady([]);
      } finally {
        setLoading(false);
      }
    };
    fetchProjects();
  }, []);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const response = await axios.get(
          "http://fundoramaa.co.in//api/v1/content/admin/"
        );
        if (response.data && Array.isArray(response.data.data)) {
          setContent(response.data.data.length);
        } else {
          console.error("Unexpected response format:", response.data);
          setContent([]);
        }
      } catch (error) {
        console.error("Error fetching projects:", error);
        setContent([]);
      } finally {
        setLoading(false);
      }
    };
    fetchProjects();
  }, []);

  return (
    <>
      <Header />

      <section>
        <div className="container mt-5">
          <div className="col-lg-6 col-12">
            <div className="row g-2">
              <div className="col-6">
                <div className="card bg-light d-flex justify-content-center h-100">
                  <div className="p-4">
                    <h2 className="fw-bold mb-1 d-flex align-items-center h1 lh-1">
                      {projects.newProjects}
                    </h2>
                    <span>
                      <span className="me-3">
                        {projects.newProjectsPending} Pending
                      </span>
                      <span className="badge bg-info mt-1">New Project</span>
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-6">
                <div className="card bg-light d-flex justify-content-center h-100">
                  <div className="p-4">
                    <h2 className="fw-bold mb-1 d-flex align-items-center h1 lh-1">
                      {projects.gapFunding}
                    </h2>
                    <span>
                      <span className="me-3">
                        {projects.gapFundingPending} Pending
                      </span>
                      <span className="badge bg-warning mt-1">GAP Funding</span>
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-6">
                <div className="card bg-light d-flex justify-content-center h-100">
                  <div className="p-4">
                    <h2 className="fw-bold mb-1 d-flex align-items-center h1 lh-1">
                      {ready}
                    </h2>
                    <span>
                      <span className="me-3">{ready} Pending</span>
                      <span className="badge bg-danger mt-1">Unreleased</span>
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-6">
                <div className="card bg-light d-flex justify-content-center h-100">
                  <div className="p-4">
                    <h2 className="fw-bold mb-1 d-flex align-items-center h1 lh-1">
                      {content}
                    </h2>
                    <span>
                      <span className="me-3">{content} Pending</span>
                      <span className="badge bg-dark mt-1">Released</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default AdminDashboard;
